import React from "react";
import { connect } from "react-redux";
import {
  reduxForm,
  formValueSelector,
  change,
  submit,
  SubmissionError,
  stopSubmit,
  destroy,
} from "redux-form";
// import validate from './validate'
import Component from "./component";
import {
  nextStep,
  previousStep,
  setFormData,
  goToStep,
  resetFormData,
  pickupBlocksApi,
  donorLocationsApi,
  leaveInitialFlow,
} from "../pickup-form.actions";
import { getPickupBlockByType } from "utils/helpers";
import { hydrateLocations } from "containers/Locations/actions";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";

/*
 *
 * Set Initial Values
 * Set any default values for this form here, they will be passed to redux form
 **/
let initialValues = {};

const mapStateToProps = (state, ownProps) => {
  const selectForm = formValueSelector("locationForm");

  const existingLocation = state.donorWizard.formValues.location;
  let addressSelected = state.donorWizard.formValues.mapAddress || null;

  if (existingLocation) {
    initialValues = {
      ...existingLocation,
    };
    addressSelected =
      existingLocation.fullAddress || existingLocation.mapAddress;
  }

  initialValues = { ...initialValues, ...ownProps.initialValues };

  let props = {
    pickupBlocks: state.donorWizard.pickupBlocks,
    isGatedCommunity: selectForm(state, "gated"),
    zipCode: state.donorWizard.formValues.zipCode || null,
    addressSelected: addressSelected,
    existingLocation: existingLocation,
  };

  return { initialValues, ...props };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  // TODO: Commit the location to the database
  const handleSubmit = (form) => {
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        const isGuest = !getState().auth.logged;

        const appState = getState();
        const { fullAddress } = form;
        const { address, city, state, zipCode, location, mapAddress } =
          appState.donorWizard.formValues;
        const { user } = ownProps;

        let userId = user.id;

        const locationQuery = {
          customerId: userId,
          zip: zipCode,
          address: address,
          city: city,
          state: state,
          fullAddress,
          mapAddress,
          ...form,
        };

        if (isGuest) {
          // Guests can't update locations
          // This forces the creation of a new one
          delete locationQuery.id;
        }

        // Remove null values
        for (var propName in locationQuery) {
          if (
            locationQuery[propName] === null ||
            locationQuery[propName] === undefined
          ) {
            delete locationQuery[propName];
          }
        }

        return dispatch(donorLocationsApi.createUpdate(locationQuery))
          .then((data) => {
            if (isGuest) {
              dispatch(hydrateLocations([data.data[0]]));
              dispatch(setFormData({ location: data.data[0] }));
            } else {
              const updatedLocation = data.data[0];
              if (!updatedLocation.fullAddress) {
                updatedLocation.fullAddress = fullAddress;
              }
              dispatch(hydrateLocations([updatedLocation]));
              dispatch(setFormData({ location: updatedLocation }));
              dispatch(leaveInitialFlow());
              Tracking.track("Step 4: Logged: Location Saved");
            }
            resolve();
          })
          .catch((err) => {
            showToastError();
            reject();
          });
      });
    };
  };

  return {
    // handleSelect: (address) => dispatch(handleSelect(address)),
    onSubmit: (form) => dispatch(handleSubmit(form)),
    onSubmitSuccess: () => {
      Tracking.track("Step 6: Location Created");
      dispatch(nextStep());
    },
    onSubmitFail: () => {
      showToastError();
    },
    previousStep: () => {
      dispatch(setFormData({ isNewDonor: true, newDonorFormComplete: false }));
      dispatch(previousStep());
    },
    previousStep: () => dispatch(previousStep()),
    setStep: (step) => dispatch(goToStep(step)),
    leaveInitialFlow: () => dispatch(leaveInitialFlow()),
  };
};

// Create a component which injects redux form state, also handles handleSubmit of the underlying form component
const withForm = reduxForm({ form: "locationForm" })(Component);

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(withForm);

// Export Complete wrapper component ( Inject Reducer -> Connect -> Redux-Form -> Component )
export default withConnect;
